import React, {
  RefObject,
} from 'react';
import {
  BenefitCard,
  PrimaryButton,
  SecondaryButton,
} from 'views/EMR/components/PCC/Walkthrough/components/ContentPrimitives';
import PageIntroduction from 'views/EMR/components/PCC/Walkthrough/components/PageIntroduction';
import type {
  NavigationPageId,
  OverviewPageDefinition,
} from 'views/EMR/components/PCC/Walkthrough/types';

type Props = {
  page: OverviewPageDefinition;
  headingRef: RefObject<HTMLHeadingElement | null>;
  bodyRef?: RefObject<HTMLDivElement | null>;
  onNavigate: (pageId: NavigationPageId) => void;
  disabled?: boolean;
};

export default function OverviewPage({
  page,
  headingRef,
  bodyRef,
  onNavigate,
  disabled = false,
}: Props) {
  return (
    <div
      ref={bodyRef}
      className="flex min-h-0 flex-1 flex-col overflow-y-auto px-4 pb-10 pt-14 sm:px-10 sm:pb-12 lg:px-[60px]"
    >
      <div className="mx-auto flex w-full max-w-[1000px] flex-1 flex-col items-center justify-center gap-8 text-center">
        <PageIntroduction
          eyebrow={page.introduction.eyebrow}
          heading={page.introduction.heading}
          description={page.introduction.description}
          headingRef={headingRef}
          align="center"
          headingSize="overview"
        />

        <div className="flex w-full flex-col gap-5 md:flex-row">
          {page.benefits.map((benefit) => (
            <BenefitCard
              key={benefit.title}
              title={benefit.title}
              description={benefit.description}
              iconKey={benefit.iconKey}
            />
          ))}
        </div>

        <div className="flex flex-col items-center gap-4 sm:flex-row sm:gap-6">
          <PrimaryButton
            showArrow
            disabled={disabled}
            className="!h-[54px] !px-[30px] !text-[17px]"
            onClick={() => onNavigate(page.primaryAction.destination)}
          >
            {page.primaryAction.label}
          </PrimaryButton>
          <SecondaryButton
            disabled={disabled}
            onClick={() => onNavigate(page.secondaryAction.destination)}
          >
            {page.secondaryAction.label}
          </SecondaryButton>
        </div>
      </div>
    </div>
  );
}
